export const blogPosts = [
  {
    id: 1,
    imgSrc: "/images/blog/blog-10.jpg",
    alt: "img-blog",
    date: "January 28, 2024",
    author: "Jerome Bell",
    category: "Furniture",
    title: "Building gains into housing stocks and how to trade the sector",
    description:
      "The average contract interest rate for 30-year fixed-rate mortgages with conforming loan balances...",
  },
  {
    id: 2,
    imgSrc: "/images/blog/blog-11.jpg",
    alt: "img-blog",
    date: "January 28, 2024",
    author: "Jerome Bell",
    category: "Furniture",
    title: "Building gains into housing stocks and how to trade the sector",
    description:
      "The average contract interest rate for 30-year fixed-rate mortgages with conforming loan balances...",
  },
  {
    id: 3,
    imgSrc: "/images/blog/blog-12.jpg",
    alt: "img-blog",
    date: "January 28, 2024",
    author: "Jerome Bell",
    category: "Furniture",
    title: "Building gains into housing stocks and how to trade the sector",
    description:
      "The average contract interest rate for 30-year fixed-rate mortgages with conforming loan balances...",
  },
];

export const blogPosts2 = [
  {
    id: 4,
    imgSrc: "/images/blog/blog-5.jpg",
    alt: "img-blog-5",
    date: "January 28, 2024",
    author: "Jerome Bell",
    category: "Furniture",
    title: "Building gains into housing stocks and how to trade the sector",
    description:
      "The average contract interest rate for 30-year fixed-rate mortgages with conforming loan balances...",
  },
  {
    id: 5,
    imgSrc: "/images/blog/blog-7.jpg",
    alt: "img-blog-7",
    date: "January 28, 2024",
    author: "Jerome Bell",
    category: "Furniture",
    title: "Building gains into housing stocks and how to trade the sector",
    description:
      "The average contract interest rate for 30-year fixed-rate mortgages with conforming loan balances...",
  },
  {
    id: 6,
    imgSrc: "/images/blog/blog-9.jpg",
    alt: "img-blog-9",
    date: "January 28, 2024",
    author: "Jerome Bell",
    category: "Furniture",
    title: "Building gains into housing stocks and how to trade the sector",
    description:
      "The average contract interest rate for 30-year fixed-rate mortgages with conforming loan balances...",
  },
];

export const blogPosts3 = [
  {
    id: 7,
    imgSrc: "/images/blog/blog-13.jpg",
    alt: "img-blog",
    date: "January 28, 2024",
    title: "Building gains into housing stocks...",
    author: "Jerome Bell",
    category: "Furniture",
  },
  {
    id: 8,
    imgSrc: "/images/blog/blog-14.jpg",
    alt: "img-blog",
    date: "January 28, 2024",
    title: "92% of millennial home buyers say inflation...",
    author: "Jerome Bell",
    category: "Furniture",
  },
  {
    id: 9,
    imgSrc: "/images/blog/blog-15.jpg",
    alt: "img-blog",
    date: "January 28, 2024",
    title: "Building gains into housing stocks and how...",
    author: "Jerome Bell",
    category: "Furniture",
  },
  {
    id: 10,
    imgSrc: "/images/blog/blog-16.jpg",
    alt: "img-blog",
    date: "January 28, 2024",
    title: "We are hiring moderately, says Compass CEO...",
    author: "Jerome Bell",
    category: "Furniture",
  },
];

export const blogPosts4 = [
  {
    id: 11,
    imgSrc: "/images/blog/blog-17.jpg",
    imgAlt: "img-blog",
    datePost: "January 28, 2024",
    author: "Jerome Bell",
    category: "Furniture",
    title: "Building gains into housing stocks and how to trade the sector",
    description:
      "The average contract interest rate for 30-year fixed-rate mortgages with conforming loan balances...",
  },
  {
    id: 12,
    imgSrc: "/images/blog/blog-18.jpg",
    imgAlt: "img-blog",
    datePost: "January 28, 2024",
    author: "Jerome Bell",
    category: "Furniture",
    title: "Building gains into housing stocks and how to trade the sector",
    description:
      "The average contract interest rate for 30-year fixed-rate mortgages with conforming loan balances...",
  },
  {
    id: 13,
    imgSrc: "/images/blog/blog-19.jpg",
    imgAlt: "img-blog",
    datePost: "January 28, 2024",
    author: "Jerome Bell",
    category: "Furniture",
    title: "Building gains into housing stocks and how to trade the sector",
    description:
      "The average contract interest rate for 30-year fixed-rate mortgages with conforming loan balances...",
  },
];

export const blogPosts5 = [
  {
    id: 14,
    imgSrc: "/images/blog/blog-5.jpg",
    imgAlt: "img-blog",
    datePost: "January 28, 2024",
    author: "Jerome Bell",
    category: "Furniture",
    title: "Building gains into housing stocks and how to trade the sector",
    description:
      "The average contract interest rate for 30-year fixed-rate mortgages with conforming loan balances...",
  },
  {
    id: 15,
    imgSrc: "/images/blog/blog-7.jpg",
    imgAlt: "img-blog",
    datePost: "January 28, 2024",
    author: "Jerome Bell",
    category: "Furniture",
    title: "Building gains into housing stocks and how to trade the sector",
    description:
      "The average contract interest rate for 30-year fixed-rate mortgages with conforming loan balances...",
  },
  {
    id: 16,
    imgSrc: "/images/blog/blog-9.jpg",
    imgAlt: "img-blog",
    datePost: "January 28, 2024",
    author: "Jerome Bell",
    category: "Furniture",
    title: "Building gains into housing stocks and how to trade the sector",
    description:
      "The average contract interest rate for 30-year fixed-rate mortgages with conforming loan balances...",
  },
];

export const blogPosts6 = [
  {
    id: 17,
    imgSrc: "/images/blog/blog-20.jpg",
    alt: "img-blog",
    date: "January 28, 2024",
    title: "Building gains into housing stocks...",
    author: "Jerome Bell",
    category: "Furniture",
  },
  {
    id: 18,
    imgSrc: "/images/blog/blog-21.jpg",
    alt: "img-blog",
    date: "January 28, 2024",
    title: "92% of millennial home buyers say inflation...",
    author: "Jerome Bell",
    category: "Furniture",
  },
  {
    id: 19,
    imgSrc: "/images/blog/blog-22.jpg",
    alt: "img-blog",
    date: "January 28, 2024",
    title: "Building gains into housing stocks and how...",
    author: "Jerome Bell",
    category: "Furniture",
  },
  {
    id: 20,
    imgSrc: "/images/blog/blog-23.jpg",
    alt: "img-blog",
    date: "January 28, 2024",
    title: "We are hiring moderately, says Compass CEO...",
    author: "Jerome Bell",
    category: "Furniture",
  },
];

export const blogPosts7 = [
  {
    id: 21,
    imgSrc: "/images/blog/blog-17.jpg",
    date: "January 28, 2024",
    author: "Jerome Bell",
    category: "Furniture",
    title: "Building gains into housing stocks and how to trade the sector",
    description:
      "The average contract interest rate for 30-year fixed-rate mortgages with conforming loan balances...",
  },
  {
    id: 22,
    imgSrc: "/images/blog/blog-18.jpg",
    date: "January 28, 2024",
    author: "Jerome Bell",
    category: "Furniture",
    title: "Building gains into housing stocks and how to trade the sector",
    description:
      "The average contract interest rate for 30-year fixed-rate mortgages with conforming loan balances...",
  },
  {
    id: 23,
    imgSrc: "/images/blog/blog-19.jpg",
    date: "January 28, 2024",
    author: "Jerome Bell",
    category: "Furniture",
    title: "Building gains into housing stocks and how to trade the sector",
    description:
      "The average contract interest rate for 30-year fixed-rate mortgages with conforming loan balances...",
  },
];

export const blogItems = [
  {
    id: 24,
    imgSrc: "/images/blog/blog-lg-1.jpg",
    title: "Building gains into housing stocks and how to trade the sector",
    category: "Furniture",
    date: "January 30",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin posuere est eget lorem viverra eleifend. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas...",
  },
  {
    id: 25,
    imgSrc: "/images/blog/blog-lg-2.jpg",
    title:
      "92% of millennial homebuyers say inflation has impacted their plans",
    category: "Furniture",
    date: "January 30",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin posuere est eget lorem viverra eleifend. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas...",
  },
  {
    id: 26,
    imgSrc: "/images/blog/blog-lg-3.jpg",
    title: "Building gains into housing stocks and how to trade the sector",
    category: "Furniture",
    date: "January 30",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin posuere est eget lorem viverra eleifend. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas...",
  },
  {
    id: 27,
    imgSrc: "/images/blog/blog-lg-4.jpg",
    title: "The Art of Staging: How to Sell Your Home Quickly at a High Price.",
    category: "Furniture",
    date: "January 30",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin posuere est eget lorem viverra eleifend. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas...",
  },
  {
    id: 28,
    imgSrc: "/images/blog/blog-lg-5.jpg",
    title: "The Art of Staging: How to Sell Your Home Quickly at a High Price.",
    category: "Furniture",
    date: "January 30",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin posuere est eget lorem viverra eleifend. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas...",
  },
];

export const blogPosts8 = [
  {
    id: 29,
    imgSrc: "/images/blog/blog-1.jpg",
    date: "January 28, 2024",
    author: { name: "Jerome Bell", category: "Furniture" },
    title: "Building gains into housing stocks and how to trade the sector",
    description:
      "The average contract interest rate for 30-year fixed-rate mortgages with conforming loan balances...",
  },
  {
    id: 30,
    imgSrc: "/images/blog/blog-2.jpg",
    date: "January 31, 2024",
    author: { name: "Angel", category: "Interior" },
    title:
      "92% of millennial homebuyers say inflation has impacted their plans",
    description:
      "Mortgage applications to purchase a home, however, dropped 4% last week compared...",
  },
  {
    id: 31,
    imgSrc: "/images/blog/blog-3.jpg",
    date: "January 28, 2024",
    author: { name: "Colleen", category: "Architecture" },
    title: "We are hiring ‘moderately,’ says Compass CEO",
    description:
      "New listings were down 20% year over year in March, according to Realtor.com, and total inventory...",
  },
  {
    id: 32,
    imgSrc: "/images/blog/blog-4.jpg",
    date: "February 01, 2024",
    author: { name: "Shane", category: "Property" },
    title: "Expert Tips for Profitable Real Estate Investments.",
    description:
      "Explore strategies and insider tips to make informed decisions when investing in real estate for maximum...",
  },
  {
    id: 33,
    imgSrc: "/images/blog/blog-5.jpg",
    date: "February 06, 2024",
    author: { name: "Eduardo", category: "Realtor" },
    title: "The Art of Staging: How to Sell Your Home Quickly at a High Price.",
    description:
      "Delve into the art of home staging as an effective strategy to attract buyers and sell your home...",
  },
  {
    id: 34,
    imgSrc: "/images/blog/blog-6.jpg",
    date: "February 09, 2024",
    author: { name: "Dianne", category: "HomeBuying" },
    title: "Key Real Estate Trends to Watch in 2024",
    description:
      "Take a comprehensive look at noteworthy and exciting trends in the real estate industry that you should...",
  },
  {
    id: 35,
    imgSrc: "/images/blog/blog-7.jpg",
    date: "February 16, 2024",
    author: { name: "Philip", category: "Furniture" },
    title: "10 Steps to Prepare for a Successful Real Estate Purchase.",
    description:
      "A detailed guide on the essential steps to meticulously prepare for a real estate purchase, ensuring...",
  },
  {
    id: 36,
    imgSrc: "/images/blog/blog-8.jpg",
    date: "February 18, 2024",
    author: { name: "Soham", category: "Interior" },
    title: "Transforming an Old House into a Modern Home.",
    description:
      "Highlighting modern architectural trends and how to update your old house to reflect a contemporary...",
  },
  {
    id: 37,
    imgSrc: "/images/blog/blog-9.jpg",
    date: "February 22, 2024",
    author: { name: "Gladys", category: "DreamHome" },
    title: "Choosing a Reliable Real Estate Agent. What You Need to Know",
    description:
      "In-depth analysis of critical factors to consider when selecting a reliable and experienced real estate...",
  },
];

export const recentPosts = [
  {
    id: 38,
    title: "Key Real Estate Trends to Watch in 2024",
    imgSrc: "/images/blog/post-recent-1.jpg",
    date: "February 16, 2024",
  },
  {
    id: 39,
    title: "Expert Tips for Profitable Real Estate Investments.",
    imgSrc: "/images/blog/post-recent-2.jpg",
    date: "February 16, 2024",
  },
  {
    id: 40,
    title: "10 Steps to Prepare for a Successful Real Estate...",
    imgSrc: "/images/blog/post-recent-3.jpg",
    date: "February 16, 2024",
  },
];

export const allBlogs = [
  ...blogPosts,
  ...blogPosts2,
  ...blogPosts3,
  ...blogPosts4,
  ...blogPosts5,
  ...blogPosts6,
  ...blogPosts7,
  ...blogPosts8,
  ...blogItems,
  ...recentPosts,
];
